import Vue from 'vue';
import Router from 'vue-router';
import AuthService from '../_ddd/auth.service';

import TianDingLoginComponent from '../views/login';
import TianDingRegisteredComponent from '../views/registered';
import TianDingForgetComponent from '../views/forget';
import TianDingClearComponent from '../views/clear';

import TianDingCodeComponent from '../views/others/code';
import TianDingFileViewComponent from '../views/others/fileView'; //pdf预览页面
import TianDingInfoComponent from '../views/others/info'; //完善资料缺省页免
import TianDingPaySuccessComponent from '../views/others/paySuccess'; //支付成功回调页免

import TianDingIndexComponent from '../views/index'; //获取微信code跳转页面

import TianDingSharedComponent from '../views/shared';
//我的
import TianDingDoctorMeComponent from '../views/me'
import TianDingDoctorMeSettingComponent from '../views/me/setting'
import TianDingDoctorMeBaseInfoComponent from '../views/me/baseInfo/index.vue'
import TianDingDoctorMeAppointmentItemComponent from '../views/me/appointmentItem'
import TianDingDoctorMeAppointmentTimeComponent from '../views/me/appointmentTime'
import TianDingDoctorMeAppointmentItemEditComponent from '../views/me/appointmentItem/edit.vue'
import TianDingDoctorMeAppointmentTimeEditComponent from '../views/me/appointmentTime/edit.vue'
import TianDingDoctorMeAppointmentRecordComponent from '../views/me/appointmentRecord'
import TianDingDoctorMeModifyPasswordComponent from '../views/me/modifyPassword'
//论坛
import TianDingDoctorForumComponent from '../views/forum'
//首页
import TianDingDoctorHomeComponent from '../views/home'

Vue.use(Router);

const routes = [{
        path: '/',
        name: 'tdIndex',
        component: TianDingIndexComponent
    },
    {
        path: '/tdLogin',
        name: 'tdLogin',
        component: TianDingLoginComponent,
        meta: {
            title: "登录"
        }
    },
    {
        path: '/tdRegistered',
        name: 'tdRegistered',
        component: TianDingRegisteredComponent,
        meta: {
            title: "注册"
        }
    },
    {
        path: '/tdForget',
        name: 'tdForget',
        component: TianDingForgetComponent,
        meta: {
            title: "忘记密码"
        }
    },
    {
        path: '/tdFileView',
        name: 'tdFileView',
        component: TianDingFileViewComponent,
        meta: {
            title: '报告查看'
        }
    },
    {
        path: '/tdInfo',
        name: 'tdInfo',
        component: TianDingInfoComponent,
        meta: {
            title: '请完善资料'
        }
    },
    {

        path: '/tdPaySuccess',
        name: 'tdPaySuccess',
        component: TianDingPaySuccessComponent,
        meta: {
            title: '支付成功'
        }
    },
    {
        path: '/tdCode',
        name: 'tdCode',
        component: TianDingCodeComponent,
        meta: {
            title: '添丁'
        }
    },
    {
        path: '/adClear',
        name: 'adClear',
        component: TianDingClearComponent,
        meta: {
            title: "清除缓存"
        }
    },
    {
        path: '/tdShared',
        name: 'tdShared',
        component: TianDingSharedComponent,
        meta: {
            title: '添丁'
        },
        redirect: {
            name: 'tdDoctorMe'
        },
        children: [{
                path: '',
                name: '',
                component: TianDingDoctorMeComponent,
                meta: {
                    title: '我的'
                }
            },
            {
                path: 'tdDoctorMe',
                name: 'tdDoctorMe',
                component: TianDingDoctorMeComponent,
                meta: {
                    title: '我的'
                }
            },
            {
                path: 'tdDoctorMeSetting',
                name: 'tdDoctorMeSetting',
                component: TianDingDoctorMeSettingComponent,
                meta: {
                    title: '设置'
                }
            },
            {
                path: 'tdDoctorMeBaseInfo',
                name: 'tdDoctorMeBaseInfo',
                component: resolve => require(['@/views/me/baseInfo/index.vue'], resolve),
                meta: {
                    title: "认证信息"
                }
            },
            {
                path: 'tdDoctorMeAppointmentItem',
                name: 'tdDoctorMeAppointmentItem',
                component: TianDingDoctorMeAppointmentItemComponent,
                meta: {
                    title: "预约项目设置"
                }
            },
            {
                path: 'tdDoctorMeAppointmentItemEdit',
                name: 'tdDoctorMeAppointmentItemEdit',
                component: TianDingDoctorMeAppointmentItemEditComponent,
                meta: {
                    title: "编辑预约项目设置"
                }
            },
            {
                path: 'tdDoctorMeAppointmentTime',
                name: 'tdDoctorMeAppointmentTime',
                component: TianDingDoctorMeAppointmentTimeComponent,
                meta: {
                    title: "预约时间设置"
                }
            },
            {
                path: 'tdDoctorMeAppointmentTimeEdit',
                name: 'tdDoctorMeAppointmentTimeEdit',
                component: TianDingDoctorMeAppointmentTimeEditComponent,
                meta: {
                    title: "编辑预约时间设置"
                }
            },
            {
                path: 'tdDoctorMeAppointmentRecord',
                name: 'tdDoctorMeAppointmentRecord',
                component: TianDingDoctorMeAppointmentRecordComponent,
                meta: {
                    title: "被预约记录"
                }
            },
            {
                path: 'tdDoctorMeModifyPassword',
                name: 'tdDoctorMeModifyPassword',
                component: TianDingDoctorMeModifyPasswordComponent,
                meta: {
                    title: "修改密码"
                }
            },
            {
                path: 'tdDoctorForum',
                name: 'tdDoctorForum',
                component: TianDingDoctorForumComponent,
                meta: {
                    title: '论坛'
                }
            }, {
                path: 'tdDoctorHome',
                name: 'tdDoctorHome',
                component: TianDingDoctorHomeComponent,
                meta: {
                    title: '首页'
                }
            }
        ]
    }
];

const router = new Router({
    mode: 'history',
    routes: routes
});

AuthService.tokenAuth(Vue, router, routes);

export default router;


// WEBPACK FOOTER //
// ./src/_routers/index.js